export { useStaticData } from './use-static-data';
